import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const ROTATIONPURPOSE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.RotationPurpose.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const ROTATIONPURPOSE_CONFIG = {
  entityName: 'RotationPurpose',
  localizationKey: 'Planning::Entity.RotationPurpose',
  fields: ROTATIONPURPOSE_FIELDS,
  permission: 'PlanningOperation.RotationPurposes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.OperationPlanning + MENU_NAME_SUFFIX,
};
